export const rootPath = '/voucher';
export const createPath = `${rootPath}/create`;
export const viewPath = `${rootPath}/batch`;
export const batchViewPath = `${viewPath}/:batchId`;

export const reportsPath = `${rootPath}/reports`;
export const vouchersReportPath = `${reportsPath}/vouchers`;

export const managersReportPath = `${reportsPath}/manager`;
export const managerReportPath = `${managersReportPath}/:routeId`;

export const complexesReportPath = `${reportsPath}/complex`;
export const complexReportPath = `${complexesReportPath}/:routeId`;

export const propertiesReportPath = `${reportsPath}/property`;
export const propertyReportPath = `${propertiesReportPath}/:routeId`;

export function getVoucherBatchPath(batchId) {
  return `${viewPath}/${batchId}`;
}

export function getVoucherPath(batchId, voucher) {
  return `${getVoucherBatchPath(batchId)}?voucher=${voucher}`;
}

export function getManagerReportPath(managerId) {
  return `${managerReportPath}/${managerId}`;
}

export function getRedeemedVoucherPath(voucher) {
  return `${vouchersReportPath}?voucher=${voucher}`;
}
